import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';




@Injectable({
  providedIn: 'root'
})
export class GtmService {
  private renderer: Renderer2;
  private injected = false;

  constructor(rendererFactory: RendererFactory2, @Inject(DOCUMENT) private doc: Document) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }


  enable(gtmId: string, clarityId: string) {
    if (this.injected) return;

    // 1️⃣ Insert GTM script at the very top of <head>
    const gtmScript = this.renderer.createElement('script');
    gtmScript.setAttribute('data-tracking-managed', 'true');
    gtmScript.type = 'text/javascript';
    gtmScript.text = `
    (function(w,d,s,l,i){
      w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),
          dl=l!='dataLayer' ? '&l='+l : '';
      j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;
    const headFirst = this.doc.head.firstChild;
    if (headFirst) {
      this.renderer.insertBefore(this.doc.head, gtmScript, headFirst);
    } else {
      this.renderer.appendChild(this.doc.head, gtmScript);
    }

    // 2️⃣ Insert Clarity script *right after* GTM script
    const clarityScript = this.renderer.createElement('script');
    clarityScript.setAttribute('data-tracking-managed', 'true');
    clarityScript.type = 'text/javascript';
    clarityScript.text = `
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;
      t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${clarityId}");
  `;
    if (gtmScript.nextSibling) {
      this.renderer.insertBefore(this.doc.head, clarityScript, gtmScript.nextSibling);
    } else {
      this.renderer.appendChild(this.doc.head, clarityScript);
    }

    // 3️⃣ Insert GTM noscript iframe as first element in <body>
    const noscript = this.renderer.createElement('noscript');
    noscript.setAttribute('data-tracking-managed', 'true');

    const iframe = this.renderer.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';

    this.renderer.appendChild(noscript, iframe);

    const bodyFirst = this.doc.body.firstChild;
    if (bodyFirst) {
      this.renderer.insertBefore(this.doc.body, noscript, bodyFirst);
    } else {
      this.renderer.appendChild(this.doc.body, noscript);
    }

    this.injected = true;
  }

  disable() {
    // Remove all injected scripts/noscripts/iframes
    this.doc.querySelectorAll('[data-tracking-managed="true"]').forEach(el => el.remove());
    this.doc.querySelectorAll(
      'script[src*="googletagmanager.com"], iframe[src*="googletagmanager.com"], script[src*="clarity.ms"]'
    ).forEach(el => el.remove());

    try { (window as any).clarity = undefined; } catch { }
    this.injected = false;
  }

}
